/* eslint-disable max-len */
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HandshakeService } from '../services/handshake.service';
import { LIB_CONFIG } from '../lib-config';
import { LibConfig } from '../models/lib-config.model';

@Injectable({
  providedIn: 'root',
})
export class WorkflowService {
  private baseUrl;
  constructor(
    private http: HttpClient,
    private handshakeService: HandshakeService,
    private router: Router,
    @Inject(LIB_CONFIG) private config: LibConfig
  ) {
    this.baseUrl = this.config?.apigeeApi?.baseUrl;
  }

  start(workflowId) {
    return this.handshakeService.getAuthorizationHeaders().pipe(
      mergeMap((authorizationHeaders: any) => {
        const apiURL = `${this.baseUrl}${this.config.compaxAngularApi.workflowEndpoints.start}/${workflowId}`;
        return this.http.post(apiURL, {}, authorizationHeaders).pipe(
          mergeMap((results: any) => {
            return of(results);
          })
        );
      })
    );
  }

  check(targetPageUID) {
    if (!targetPageUID) {
      this.router.navigateByUrl('/');
    } else {
      return this.handshakeService.getAuthorizationHeaders().pipe(
        mergeMap((authorizationHeaders: any) => {
          const apiURL = `${this.baseUrl}${this.config.compaxAngularApi.workflowEndpoints.check}/${targetPageUID}`;
          return this.http.post(apiURL, {}, authorizationHeaders).pipe(
            mergeMap((results: any) => {
              return of(results);
            })
          );
        })
      );
    }
  }

  next() {
    return this.handshakeService.getAuthorizationHeaders().pipe(
      mergeMap((authorizationHeaders: any) => {
        const apiURL = `${this.baseUrl}${this.config.compaxAngularApi.workflowEndpoints.next}`;
        return this.http.post(apiURL, {}, authorizationHeaders).pipe(
          mergeMap((results: any) => {
            return of(results);
          })
        );
      })
    );
  }

  back() {
    return this.handshakeService.getAuthorizationHeaders().pipe(
      mergeMap((authorizationHeaders: any) => {
        const apiURL = `${this.baseUrl}${this.config.compaxAngularApi.workflowEndpoints.back}`;
        return this.http.post(apiURL, {}, authorizationHeaders).pipe(
          mergeMap((results: any) => {
            return of(results);
          })
        );
      })
    );
  }

  setNextReturnCode(returnCodeRef) {
    return this.handshakeService.getAuthorizationHeaders().pipe(
      mergeMap((authorizationHeaders: any) => {
        const apiURL = `${this.baseUrl}${this.config.compaxAngularApi.workflowEndpoints.nextReturnCode}/${returnCodeRef}`;
        return this.http.post(apiURL, {}, authorizationHeaders).pipe(
          mergeMap((results: any) => {
            return of(results);
          })
        );
      })
    );
  }

  goToNextReturnCode(returnCodeRef) {
    return this.handshakeService.getAuthorizationHeaders().pipe(
      mergeMap((authorizationHeaders: any) => {
        const apiURL = `${this.baseUrl}${this.config.compaxAngularApi.workflowEndpoints.goToNextReturnCode}/${returnCodeRef}`;
        return this.http.post(apiURL, {}, authorizationHeaders).pipe(
          mergeMap((results: any) => {
            return of(results);
          })
        );
      })
    );
  }

  current() {
    return this.handshakeService.getAuthorizationHeaders().pipe(
      mergeMap((authorizationHeaders: any) => {
        const apiURL = `${this.baseUrl}${this.config.compaxAngularApi.workflowEndpoints.current}`;
        return this.http.get(apiURL, authorizationHeaders).pipe(
          mergeMap((results: any) => {
            return of(results);
          })
        );
      })
    );
  }
}
